import { render } from "./LandingSection.vue?vue&type=template&id=25abea3b"
import script from "./LandingSection.vue?vue&type=script&lang=js"
export * from "./LandingSection.vue?vue&type=script&lang=js"

import "./LandingSection.vue?vue&type=style&index=0&id=25abea3b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__